"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patchOrganizationsPolicies = exports.getOrganizationsPolicies = void 0;

const getOrganizationsPolicies = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/policies`;
  const params = {};
  return jilFetch(path, params, {
    method: 'GET'
  });
};

exports.getOrganizationsPolicies = getOrganizationsPolicies;

const patchOrganizationsPolicies = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/policies`;
  return jilFetch(path, {}, {
    body: JSON.stringify(options.operations),
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'PATCH'
  });
};

exports.patchOrganizationsPolicies = patchOrganizationsPolicies;